import { MenuUsuario } from "@core/services/ruta-dinamica.service";

export type ItemMenu = MenuUsuario["lista"][number];

/** Primer segmento de la URL, sin query ni fragment: es el `path` con que el menú registra la pantalla. */
export function obtenerPathRaiz(url: string): string {
  const sinQuery = url.split(/[?#]/)[0];
  return sinQuery.split("/").find((segmento) => segmento !== "") ?? "";
}

/**
 * Módulo del menú al que pertenece la URL. Si la pantalla figura en más de un módulo,
 * se queda con `actual` para no cambiarle el menú al usuario. `null` si no figura en ninguno.
 */
export function resolverModuloDeRuta(
  items: ItemMenu[],
  url: string,
  actual: string,
): string | null {
  const path = obtenerPathRaiz(url);
  if (!path) return null;

  const modulos = items
    .filter((item) => item.tipo === "F" && item.path === path)
    .map((item) => item.codmod);

  if (modulos.length === 0) return null;
  return modulos.includes(actual) ? actual : modulos[0];
}
